import { schema } from "normalizr";
import { createRecord as createItemRecord } from "records/item";

export const ItemSchema = new schema.Entity(
    "items",
    {},
    {
        idAttribute: "_id",
        processStrategy: (value, parent) => {
            value.__out_of_range = parent.__out_of_range;
            return value;
        },
    },
);

(ItemSchema as any).record = createItemRecord;
